<!-- 顶部菜单 -->
<template>
	<!-- 电脑端菜单 -->
	<div v-if="!phoneScreen" class="topMenuAnchor">
		<!-- 一级菜单 -->
		<div class="inlineMenu">
			<template v-for="route in menuList">
				<div class="menuItem" v-if="!route.hidden" :key="route.name">
					<!-- 一级菜单文字 -->
					<div class="menuTitle">{{ route.meta.title }}</div>
					<!-- 二级菜单 -->
					<ul class="columnMenu" v-if="route.children.length > 0" :style="{'--height':menuBlockHeight}">
						<template v-for="(item, index) in route.children">
							<li v-if="!item.hidden" :key="index" @click="turn2page(item.name, item.objid)">{{ item.meta.title }}</li>
						</template>
					</ul>
				</div>
			</template>
			<!-- 菜单块，即二级菜单灰色部分 -->
			<div class="menuBlock" :style="{'--height':menuBlockHeight}"></div>
		</div>
	</div>

	<!-- 移动端菜单 -->
	<div v-else class="phoneMenuAnchor">
		<i class="openMenuIcon el-icon-more" @click="openMenuList"></i>
		<div class="phoneMenuList" :style="listHeight">
			<template v-for="(route, index) in menuList">
				<div style="position: relative" v-if="!route.hidden" :key="route.name">
					<!-- 一级菜单文字 -->
					<div class="AtypeMenu" @click="openFollow(index)">{{ route.meta.title }}</div>
					<i class="rightArrow el-icon-arrow-right"></i>
					<!-- 二级菜单 -->
					<ul class="BtypeMenu" :style="ulHeight[index]" v-if="route.children.length > 0">
						<template v-for="(item, index) in route.children">
							<li v-if="!item.hidden" :key="index" @click="turn2page(item.name, item.objid)">{{ item.meta.title }}</li>
						</template>
					</ul>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
export default {
	name: 'top-menu',
	data() {
		return {
			menuList: [],
			productList: [],

			menuBlockHeight: '',
			phoneScreen: false,
			listHeight: '',
			ulHeight: [],
		};
	},
	created() {
		this.initService();
		if (document.body.clientWidth < 1200) this.phoneScreen = true;
		else this.phoneScreen = false;
	},
	mounted() {
		
	},
	methods: {
		turn2page(name, objid) {
			this.listHeight = '';
			// 产品服务单独处理
			if (name === 'productIntroduction') {
				this.$router.push({ name: name, query: { objid: objid } });
				return;
			}
			if (this.$route.name === name) return;
			this.$router.push({ name });
		},
		initService() {
			this.$API.getProductList({}, (res) => {
				this.productList = res.list;
				this.initMenu();
			});
		},
		initMenu() {
			let routeList = this.$VUEX.getters.menuList;
			let finList = [];
			this.$API.getNavbar({ refgrp: 'OW_NAVI_BAR' }, (res) => {
				let sonList = res;
				routeList.forEach((item) => {
					// 产品服务单独处理
					if (item.name === 'productService') {
						sonList.forEach((element) => {
							if (element.navi_cd === 'PRODUCT_SERVICE') {
								item.meta.title = element.navi_name;
							}
						});
						let childList = [];
						this.productList.forEach((ele) => {
							let child = { meta: {}, name: 'productIntroduction' };
							child.meta.title = ele.product_name;
							child.objid = ele.objid;
							childList.push(child);
						});
						item.children = childList;
						finList.push(item);
						this.ulHeight.push('');
					} else if (item.name === 'information') {
						// 联系我们单独处理（无二级菜单）
						sonList.forEach((element) => {
							if (element.navi_cd === 'CONNECT_US') {
								item.meta.title = element.navi_name;
							}
						});
						item.children[0].meta.title = item.meta.title;
						finList.push(item);
						this.ulHeight.push('');
					} else {
						sonList.forEach((element) => {
							if (item.meta && element.is_enabled == 1 && element.navi_cd === item.meta.value) {
								item.meta.title = element.navi_name;
								finList.push(item);
								this.ulHeight.push('');
							}
						});
						if (item.children) {
							let childList = [];
							item.children.forEach((child) => {
								sonList.forEach((element) => {
									if (child.meta && element.is_enabled == 1 && element.navi_cd === child.meta.value) {
										child.meta.title = element.navi_name;
										childList.push(child);
									}
								});
							});
							item.children = childList;
						}
					}
				});
				this.menuList = finList;
				// 二级菜单背景高度获取
				let maxChildren = 0;
				this.menuList.forEach((item) => {
					if (item.children.length > maxChildren) {
						maxChildren = item.children.length;
					}
				});
				this.menuBlockHeight = maxChildren * 40 + 'px' 
			});
		},

		// 小屏菜单相关
		openMenuList() {
			if (this.listHeight) this.listHeight = '';
			else this.listHeight = 'height: 100vh;';
		},
		openFollow(index) {
			if (this.ulHeight[index]) this.$set(this.ulHeight, index, '');
			else this.$set(this.ulHeight, index, `height: ${this.menuList[index].children.length * 43}px;`);
		},
	},
	watch: {},
};
</script>

<style scoped>
.topMenuAnchor {
	position: relative;
	float: right;
	margin-top: -18px;
}
.inlineMenu {
	display: flex;
}
.menuBlock {
	position: absolute;
	top: 80px;
	right: -100px;
	display: block;
	background-color: #3333334d;
	width: 100vw;
	/* height: auto; */
	transition-duration: height 0.5s;
	transition: height 0.5s;
	z-index: -1;
}
.menuTitle {
	color: #8b8582;
	font-size: 18px;
	line-height: 40px;
	padding: 20px 28px;
	cursor: pointer;
}
.columnMenu {
	display: none;
	margin: 0;
	padding: 0;
	height: var(--height);
}
.menuItem:hover .columnMenu {
	background-color: #164290;
}
.columnMenu li {
	list-style-type: none;
	line-height: 16px;
	padding: 12px 32px;
	color: #ffffff;
	cursor: pointer;
}
.inlineMenu:hover .menuBlock {
	height:var(--height);
}
.menuItem:hover .menuTitle {
	color: #409eff;
}
.inlineMenu:hover .columnMenu {
	display: block;
}
.columnMenu li:hover {
	background-color: #409eff;
}
</style>

<style scoped>
.phoneMenuAnchor {
	position: absolute;
    width: 80px;
    height: 80px;
    top: 0;
    right: 0;
    line-height: 96px;
    background-color: #fff;
}
.openMenuIcon {
	font-size: 40px;
	/* background-color: #fff; */
    /* padding-left: 20px; */
}
.phoneMenuList {
	position: absolute;
	width: 100vw;
	height: 0;
	right: 0;
	top: 80px;
	line-height: 22px;
	text-align: left;
	overflow: hidden;
	transition-duration: height 0.5s;
	transition: height 0.5s;
}
.AtypeMenu {
	color: #ffffff;
	padding: 10px 20px;
	background-color: rgba(51, 51, 51, 0.8);
	border-bottom: 1px solid rgba(255, 255, 255, 0.15);
}
.rightArrow {
	position: absolute;
	right: 12px;
	top: 12px;
	color: #ffffff;
	font-size: 20px;
}
.BtypeMenu {
	margin: 0;
	padding: 0;
	height: 0;
	overflow: hidden;
	transition-duration: height 0.5s;
	transition: height 0.5s;
}
.BtypeMenu li {
	/* display: none; */
	list-style-type: none;
	border-bottom: 1px solid rgba(255, 255, 255, 0.15);
	background-color: #164290;
	padding: 10px 20px;
	color: #86a6f0;
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pageLayout/topMenu.vue